@if (displayInline()) {
  <div data-test="order-confirmation__customer-voice" id="surveyDiv"></div>
}
